module.exports = __webpack_public_path__ + "img/pin-emerald.c0f373a6.png";